'use client';

import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';

import styles from './button-like-radio-group.component.module.scss';

type ButtonLikeRadioGroupProps = ComponentPropsWithoutRef<'div'>;

/**
 * ButtonLikeRadioGroupは複数のButtonLikeRadioをグループ化するためのコンポーネント。
 */
export const ButtonLikeRadioGroup = forwardRef<
  HTMLDivElement,
  ButtonLikeRadioGroupProps
>(({ className, ...rest }, forwardedRef) => {
  return (
    <div
      className={[className, styles.buttonLikeRadioGroup]
        .filter(Boolean)
        .join(' ')}
      ref={forwardedRef}
      {...rest}
    />
  );
});

ButtonLikeRadioGroup.displayName = 'ButtonLikeRadioGroup';
